const state = {
  students: [],
  student: null,
  processing: false,
  processingStudent: false,
};

export default state;
